import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [
	{
		name: 'NFA Dashboard',
		url: '/nfa',
		icon: 'archive',
	},
];

export default class NFA extends Framework.Components.View {

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				{this.props.locations
					.filter(
						/**
						 * @param {Locations_Object} location
						 * @returns {boolean}
						 */
						location => !location.archived)
					.map(
						/**
						 * @param {Locations_Object} location
						 * @param key
						 */
						(location, key) =>
							<Objects.NFA
								key={key}
								parent={location.pkey}
								parent_binary_id={location.binary_id}
								location={location}
								history={this.props.history}
								locations={this.props.locations}
								states={this.props.states}
								reloadShell={this.props.reloadShell}
								reloadPage={this.refreshPage}
								reloadSelf={this.state.refresh}
							/>
					)
				}

			</div>
		)
	}
};



